import React from "react";
import "./Loading.css";

const Loader = ({ loading }) => {
    return (
        <>
            {loading && (
                <div className="loading-container">
                    <div className="lds-roller">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Loader;
